import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { AdminFormPage } from "@components/CatalogIndex";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { PhaseForm } from "../PhaseForm/PhaseForm";
import { usePhaseMutations } from "../api/usePhaseMutations";
import type { PhaseFormValues } from "../types/Phase";

const FORM_ID = "phase-form";

const initial: PhaseFormValues = {
  name: "",
  sowLanguage: "",
  isDefault: false,
};

export const New = () => {
  const navigate = useNavigate();
  const { create } = usePhaseMutations();
  const [submitting, setSubmitting] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [toast, setToast] = useState<{
    variant: "success" | "danger";
    text: string;
  } | null>(null);
  const nextActionRef = useRef<"back" | "add-another">("back");

  const handleSubmit = async (values: PhaseFormValues) => {
    const nextAction = nextActionRef.current;
    nextActionRef.current = "back";
    setSubmitting(true);
    try {
      const result: any = await create(values);
      if (nextAction === "add-another") {
        setFormKey((k) => k + 1);
        setToast({ variant: "success", text: "Phase created." });
      } else {
        const newId = result?.data?.id;
        if (newId) {
          navigate(`../${newId}/edit`, {
            state: {
              toast: { variant: "success", text: "Phase created." },
            },
          });
        } else {
          setToast({ variant: "success", text: "Phase created." });
        }
      }
    } catch (err) {
      console.error("Failed to create phase", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSaveAndAddAnother = () => {
    nextActionRef.current = "add-another";
    (
      document.getElementById(FORM_ID) as HTMLFormElement | null
    )?.requestSubmit();
  };

  return (
    <>
      <AdminFormPage
        title="Add a Phase"
        formId={FORM_ID}
        onCancel={() => navigate("..")}
        onSaveAndAddAnother={handleSaveAndAddAnother}
        isSubmitting={submitting}
      >
        <PhaseForm
          key={formKey}
          id={FORM_ID}
          initialValues={initial}
          isPersisted={false}
          isSubmitting={submitting}
          onSubmit={handleSubmit}
        />
      </AdminFormPage>
      {toast && (
        <ToastAlert
          variant={toast.variant}
          text={toast.text}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};
